"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 19.1",
    width: "44",
    height: "19.1"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M17.5,19c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S18.9,19,17.5,19z M17.5,15 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S18.4,15,17.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M32.8,19c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S34.1,19,32.8,19z M32.8,15 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S33.6,15,32.8,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M43.5,17h-3.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H43V1H12.3l0,3.5c0,0,0,6,0,7.8h8.6 c0.3,0,0.5,0.2,0.5,0.5v3.5c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-3h-8.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0-8.3,0-8.3l0-4 c0-0.3,0.2-0.5,0.5-0.5h31.7C43.8,0,44,0.2,44,0.5v16C44,16.8,43.8,17,43.5,17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3.1,17H0.5C0.2,17,0,16.8,0,16.5V11c0-0.1,0.1-0.3,0.1-0.4l2-2l2.5-4.4C4.7,4.1,4.8,4,5,4h4.5 C9.8,4,10,4.2,10,4.5S9.8,5,9.5,5H5.3L2.9,9.2c0,0-0.1,0.1-0.1,0.1L1,11.2V16h2.1c0.3,0,0.5,0.2,0.5,0.5S3.3,17,3.1,17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M3.1,16.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M10.5,17H7.1c-0.3,0-0.5-0.2-0.5-0.5S6.8,16,7.1,16h3.4c0.3,0,0.5,0.2,0.5,0.5S10.8,17,10.5,17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M30.3,17H19.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10.7c0.3,0,0.5,0.2,0.5,0.5S30.6,17,30.3,17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.5,10c-0.1,0-0.2,0-0.2-0.1C4,9.8,3.9,9.5,4.1,9.3l1.5-3C5.6,6.1,5.8,6,6,6h1.5C7.8,6,8,6.2,8,6.5 S7.8,7,7.5,7H6.3L4.9,9.7C4.9,9.9,4.7,10,4.5,10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9.5,16.6c-0.3,0-0.5-0.2-0.5-0.5V4.5C9,4.2,9.2,4,9.5,4S10,4.2,10,4.5v11.6C10,16.4,9.8,16.6,9.5,16.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M43.1,14.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9.5,15h-9C0.2,15,0,14.8,0,14.5S0.2,14,0.5,14h9c0.3,0,0.5,0.2,0.5,0.5S9.8,15,9.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M12.8,19c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S14.2,19,12.8,19z M12.8,15 c-0.8,0-1.5,0.7-1.5,1.5S12,18,12.8,18s1.5-0.7,1.5-1.5S13.6,15,12.8,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M5.1,19c-1.4,0-2.5-1.1-2.5-2.5S3.7,14,5.1,14s2.5,1.1,2.5,2.5S6.4,19,5.1,19z M5.1,15 c-0.8,0-1.5,0.7-1.5,1.5S4.2,18,5.1,18s1.5-0.7,1.5-1.5S5.9,15,5.1,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M37.5,19.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S38.9,19.1,37.5,19.1z M37.5,15.1 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S38.3,15.1,37.5,15.1z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "26.1",
    cy: "7.7",
    r: "4.3"
  }));
};

exports["default"] = _default;